import { useState, useEffect } from 'react';
function useVisualViewportSize() {
    // @ts-expect-error
    const hasApi = !!window.visualViewport;
    const isClient = typeof window !== 'undefined';
    const [visualViewportSize, setVisualViewportSize,] = useState({ height: window.innerHeight, width: window.innerWidth });
    useEffect(() => {
        // Do nothing if we're not in web env
        if (!isClient || !hasApi) {
            return () => { };
        }
        // Handler to call on window resize
        function handleResize() {
            // capture event
            const newDimensions = {
                // @ts-expect-error
                width: window.visualViewport.width,
                // @ts-expect-error
                height: window.visualViewport.height,
            };
            setVisualViewportSize(newDimensions);
        }
        // Add event listener
        // @ts-expect-error
        window.visualViewport.addEventListener('resize', handleResize);
        // Remove event listener on cleanup
        return () => window.removeEventListener('resize', handleResize);
    }, []); // Empty array ensures that effect is only run on mount
    return visualViewportSize;
}
export default useVisualViewportSize;
//# sourceMappingURL=useVisualViewportSize.js.map